var BraintreeHelper = (function (CheckoutSettings, GlobalSettings) {
	return function (token) {
		var bt = new BraintreeModule({
			stylesOptions: {
				'input': { 'font-size': '12px', 'color': '#333333', 'font-family': 'Verdana', 'font-weight': 'normal' },
				'input:focus:-moz-placeholder': { 'color': 'transparent' },
				'input:focus::-moz-placeholder': { 'color': 'transparent' },
				'input:focus::-webkit-input-placeholder': { 'color': 'transparent' },
				'input:focus:-ms-input-placeholder': { 'color': 'transparent' }
			},
			fieldsOptions: {
				number: { selector: '#card-number', placeholder: '1234 1234 1234 1234' },
				cvv: { selector: '#cvv', placeholder: '100' },
				expirationDate: { selector: '#expiration-date', placeholder: 'MM / YY' }
			},
			fieldErrorClass: 'braintree-hosted-fields-invalid'
		});

		token.done(function (clienToken) {
		    CheckoutSettings.ready(function(s) {
				var settings = _.pick(s, 'BTEnvironment', 'KountEnabled', 'KountMerchantID', 'UsePayPal', 'PayPalEnvironment', 'StripeEnabled');

		        bt.init({
		            token: clienToken,
		            btEnvironment: settings.BTEnvironment.toLowerCase(),
		            kountEnabled: settings.KountEnabled,
		            kountMerchantID: settings.KountMerchantID,
		            usePayPal: settings.UsePayPal,
		            payPalEnvironment: settings.PayPalEnvironment,
		            currency: GlobalSettings.CurrencySign,
		            currencyIso: GlobalSettings.Currency,
					useHostedfields: !settings.StripeEnabled
		        });
		    });
		});

		return bt;
	};

})(CheckoutSettings, GlobalSettings);